export const module = {
  info: {
    name: 'voip-dialplan-sms',
    caption: 'voip dialplan SMS',
    viewGroup: 'fasfreeroute-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    caption: 'Dialplan SMS',
    icon: 'el-icon-phone',
    routeName: 'module->voip-dialplan-sms->create',
    children: [
      {
        caption: 'Create SMS Dialplan',
        icon: 'el-icon-plus',
        routeName: 'module->voip-dialplan-sms->create'
      },
      {
        caption: 'List Dialplans',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-dialplan-sms->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
